export const TEXT_FIELD_MAX_LENGTH = 120;
